import { Component } from '@angular/core';

@Component({
  selector: 'cert-pd-recent-awards-actions-cell-renderer',
  templateUrl: './pd-recent-awards-actions-cell-renderer.component.html',
  styles: ``,
  standalone: false,
})
export class ProfessionalDevelopmentRecentAwardsActionsCellRenderer {
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  update() {
    this.params.context.componentParent.selectedPDRecordIds.set([this.params.data.professionalDevelopmentRecordId]);
    this.params.context.componentParent.onUpdate(
      this.params.data.description,
      this.params.data.hours,
      this.params.data.completionDate,
      this.params.data.professionalDevelopmentTypeCodeId,
    );
    this.params.context.componentParent.selectedPDRecordIds.set([]);
    this.params.context.componentParent.gridApi.deselectAll();
  }

  delete() {
    this.params.context.componentParent.selectedPDRecordIds.set([this.params.data.professionalDevelopmentRecordId]);
    this.params.context.componentParent.onDelete();
    this.params.context.componentParent.selectedPDRecordIds.set([]);
    this.params.context.componentParent.gridApi.deselectAll();
  }

  refresh(params: any): boolean {
    return false;
  }
}
